<div class="login_page">
  <div class="lg_main">
    <div class="lg_right eq_H" [ngStyle]="{ height: innerHeight }">
      <img src="https://purchasepointe.spark-staging.dev/assets/images/loginpage.jpg" />
    </div>
    <div class="lg_left eq_H" [ngStyle]="{ height: innerHeight }">
      <div class="lg_left_inner">
        <div class="full_width text-center">
          <div class="logoodsas">
            <div class="logoodsas_inner">
              <img src="https://purchasepointe.spark-staging.dev/uploads/site_logo/1581523657_aelogo.png" />
            </div>
          </div>
        </div>
        <div class="form_main loginHJL">
          <form [formGroup]="loginForm" (ngSubmit)="onSubmit(loginForm)">
            <div class="lg_form_inner">
              <p class="sessError"></p>
              <div id="error-display"></div>
              <input type="hidden" name="is_login" value="1" />
              <input type="hidden" name="referrer" value="" />
              <div class="form-group">
                <label>Email</label>
                <input
                  type="text"
                  placeholder="Email Address"
                  class="form-control"
                  value=""
                  autofocus
                  formControlName="email" />
                <span
                  class="error"
                  *ngIf="loginForm.get('email').hasError('required') && loginForm.get('email').touched">
                  Please Provide An Email Address.
                </span>
                <span class="error" *ngIf="loginForm.get('email').hasError('email')">
                  Please Provide A Valid Email Address.
                </span>
              </div>
              <div class="form-group">
                <label>Password</label>
                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  class="form-control"
                  value=""
                  formControlName="password" />
                <span
                  class="error"
                  *ngIf="loginForm.get('password').hasError('required') && loginForm.get('password').touched">
                  Please Provide A Password.
                </span>
              </div>
              <div class="form-group setstruforgot">
                <div class="row">
                  <div class="col-sm-6">
                    <label class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        formControlName="remember"
                        [value]="1"
                        checked />
                      <span class="custom-control-indicator"></span>
                      <span class="custom-control-description">Remember me</span>
                    </label>
                  </div>
                  <div class="col-sm-6">
                    <a
                      class="lg_btn_coolsx mr5sx float-right"
                      data-toggle="modal"
                      data-target="#forgotmodal"
                      (click)="resetForgotPasswordForm()"
                      href="javascript:void(0)"
                      >Forgot Password?</a
                    >
                  </div>
                </div>
              </div>
              <div class="form-group mrg50 mrzerox btmzeroxz text-left">
                <button type="submit" class="lg_btn_coolsx mr5sx full_width">Login</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div id="forgotmodal" class="modal fade loginxc_mdl" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Forgot Password?</h4>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <div class="forgot_pass_form">
              <p>Please type in the account email address to reset your password</p>
              <form [formGroup]="forgotPasswordForm" (ngSubmit)="onForgotPasswordSubmit(forgotPasswordForm)">
                <div id="forgotpwd-error-display"></div>
                <p class="sessError"></p>
                <input type="hidden" name="is_forgot" value="1" />
                <div class="form-group">
                  <input
                    type="text"
                    name="email"
                    id="forgot_email"
                    class="form-control"
                    placeholder="Enter Email"
                    formControlName="email" />
                  <span
                    class="error"
                    *ngIf="
                      forgotPasswordForm.get('email').hasError('required') && forgotPasswordForm.get('email').touched
                    ">
                    Please Provide A Valid Email Address.
                  </span>
                  <span class="error" *ngIf="forgotPasswordForm.get('email').hasError('email')">
                    Please Provide A Valid Email Address.
                  </span>
                </div>
                <div class="form-group mrzero text-center">
                  <input type="submit" value="Send Email" class="lg_btn_coolsx mr5sx bgnonexd wdy" />
                  <a class="lg_btn_coolsx mr5sx wdy" href="javascript:void(0)" data-dismiss="modal" #closebutton
                    >Cancel</a
                  >
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
